module.exports = __webpack_public_path__ + "static/media/checkbox_on.c0aa047e.svg";